<div class="flex-direction-column gap-5">
  @if (label) {
    <span class="campo-label">{{ label }}</span>
  }
  <textarea
    class="campo-textarea-base"
    [class.campo-input-erro]="erro"
    [rows]="linhas"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [attr.maxlength]="maxLength"
    [value]="valor"
    (input)="aoDigitar($any($event.target).value)"
    (blur)="aoTocar()"></textarea>
  <span class="campo-textarea-contador" [class.campo-textarea-contador-limite]="totalCaracteres >= maxLength">
    {{ totalCaracteres }}/{{ maxLength }}
  </span>
  @if (erro) {
    <span class="campo-erro-texto">{{ erro }}</span>
  }
</div>
